import React, { PureComponent } from "react";
import OfferResult from "./OfferResult";
import OfferResultsLayout from "../../../shared/OfferResultsLayout";

class OfferResults extends PureComponent {
  render() {
    const {
      clientConfig,
      collapsed,
      currentPage,
      offerType,
      onCollapseClick,
      portal,
      portalOfferResults,
      onPageClick,
      totalPages,
      updateExperiment,
      updateModal,
      widgetOptions
    } = this.props;

    return (
      <OfferResultsLayout
        clientConfig={clientConfig}
        collapsed={collapsed}
        currentPage={currentPage}
        offerResultComponent={OfferResult}
        offerType={offerType}
        onCollapseClick={onCollapseClick}
        onPageClick={onPageClick}
        portal={portal}
        portalOfferResults={portalOfferResults}
        totalPages={totalPages}
        updateExperiment={updateExperiment}
        updateModal={updateModal}
        widgetOptions={widgetOptions}
      />
    );
  }
}

export default OfferResults;
